module.exports = __webpack_public_path__ + "assets/img/Logo4.7105220c.png";